var _path, _g, _g2, _path2, _path3, _path4, _path5, _path6, _path7, _g3, _g4, _g5, _path8, _path9, _path10, _path11, _path12, _path13, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgAchievementsEmptyStateCompleted = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 226,
  height: 202,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  className: "dd-privacy-hidden"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M23.243 40.432C23.243 30.805 31.048 23 40.675 23H184.36c9.628 0 17.433 7.805 17.433 17.432 0 9.628-7.805 17.433-17.433 17.433H40.675c-9.627 0-17.432-7.805-17.432-17.433Zm23.244 34.865c0-9.627 7.804-17.432 17.432-17.432h143.685c9.628 0 17.432 7.805 17.432 17.432 0 9.628-7.804 17.433-17.432 17.433H63.919c-9.628 0-17.432-7.805-17.432-17.433ZM17.431 92.734C7.805 92.734 0 100.538 0 110.166c0 9.628 7.805 17.433 17.432 17.433h39.612c-9.38.283-16.896 7.975-16.896 17.424 0 9.627 7.804 17.432 17.432 17.432h143.685c9.628 0 17.433-7.805 17.433-17.432 0-9.628-7.805-17.433-17.433-17.433h-39.612c9.38-.283 16.897-7.975 16.897-17.424 0-9.628-7.805-17.432-17.432-17.432H17.432Zm9.51 69.725c-9.628 0-17.433 7.805-17.433 17.433 0 9.627 7.805 17.432 17.432 17.432h157.42c9.628 0 17.433-7.805 17.433-17.432 0-9.628-7.805-17.433-17.433-17.433H26.941Z",
  fill: "#fff"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#achievements-empty-state-completed_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M171.1 177.445a1.045 1.045 0 0 0 1.478.08l11.084-9.942-.152-.166c-3.657-4.076-3.311-10.349.772-14.011 4.082-3.663 10.356-3.327 14.012.749.051.056.1.112.149.169l12.002-10.767a1.047 1.047 0 0 0 .08-1.479l-10.334-11.52.001-.001c4.082-3.663 4.428-9.936.772-14.012-3.656-4.075-9.93-4.411-14.013-.748l-.001.001-10.334-11.52a1.047 1.047 0 0 0-1.479-.081l-11.541 10.354c3.657 4.076 3.311 10.349-.772 14.011-4.082 3.663-10.356 3.327-14.012-.749h-.001l-11.54 10.353a1.045 1.045 0 0 0-.08 1.478l33.909 37.801Z",
  fill: "#BCDAF2"
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#achievements-empty-state-completed_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m29.17 81.892 72.85-20.106 30.717 111.295-72.852 20.106z"
}))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#EDF4F3",
  d: "m34.602 84.873 64.28-17.741 23.261 84.28-64.28 17.74z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M57.548 117.109a4.982 4.982 0 0 1 3.431-6.153l3.427-.973a4.98 4.98 0 0 0 2.36-1.479l2.009-2.257a4.98 4.98 0 0 1 2.36-1.48l3.411-.969 3.412-.969a4.98 4.98 0 0 1 2.785.019l2.896.864a4.988 4.988 0 0 0 2.785.019l3.427-.973a4.98 4.98 0 0 1 6.153 3.431l4.538 15.98a4.982 4.982 0 0 1-3.431 6.153l-28.872 8.199a4.982 4.982 0 0 1-6.153-3.431l-4.538-15.981Z",
  fill: "#405B73",
  fillOpacity: 0.85
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M76.394 109.888c-5.476 1.555-8.677 7.278-7.126 12.739 1.551 5.462 7.297 8.699 12.772 7.144 5.476-1.555 8.663-7.329 7.112-12.79-1.551-5.462-7.282-8.648-12.758-7.093Z",
  fill: "#F4CC54",
  fillOpacity: 0.85
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M77.262 112.945c-3.793 1.077-6.009 5.033-4.936 8.812 1.073 3.779 5.052 6.03 8.845 4.953 3.793-1.077 5.994-5.083 4.92-8.862-1.072-3.78-5.036-5.98-8.83-4.903Z",
  fill: "#F3F5F9",
  fillOpacity: 0.85
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M60.798 115.569a.885.885 0 0 1 .61-1.093l3.406-.968a.886.886 0 0 1 .484 1.703l-3.406.968a.885.885 0 0 1-1.094-.61Z",
  fill: "#F4CC54",
  fillOpacity: 0.85
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "m89.216 102.987-3.406.967a.885.885 0 1 1-.484-1.703l3.406-.967a.884.884 0 1 1 .484 1.703Z",
  fill: "#DDBE5B"
})), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#achievements-empty-state-completed_svg__c)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M106.296 86.466c2.06-4.997-.328-10.72-5.333-12.784a10.107 10.107 0 0 0-.911-.325l6.601-16.014a.628.628 0 0 1 .82-.34l15.536 6.404a9.801 9.801 0 0 1 12.067-3.89 9.8 9.8 0 0 1 5.821 11.263l13.752 5.67c.321.131.474.498.341.819l-6.616 16.051c.338.099.674.216 1.007.353 5.005 2.064 7.393 7.787 5.333 12.784-2.06 4.998-7.787 7.376-12.793 5.313a10.148 10.148 0 0 1-.963-.459l-5.381 13.054a.628.628 0 0 1-.82.341L87.58 105.259a.628.628 0 0 1-.34-.82l5.388-13.072c.282.15.574.287.875.412 5.005 2.063 10.733-.315 12.793-5.313Z",
  fill: "#5A7286"
}))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#achievements-empty-state-completed_svg__d)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M178.058 25.623a1.255 1.255 0 0 0-.676-1.642L130.185 4.345a1.255 1.255 0 0 0-1.641.677l-5.469 13.145c-5.128-2.134-10.883-.02-12.855 4.72-1.972 4.74.586 10.311 5.713 12.445l-5.469 13.145c-.266.64.037 1.375.677 1.641l14.314 5.956h.001c1.972-4.74 7.727-6.854 12.855-4.72 5.127 2.133 7.685 7.704 5.713 12.444v.001l14.313 5.955a1.256 1.256 0 0 0 1.642-.677l5.294-12.724c5.073 1.988 10.696-.132 12.641-4.806 1.945-4.674-.516-10.157-5.501-12.354l5.645-13.57Z",
  fill: "#DDBE5B"
}))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#achievements-empty-state-completed_svg__e)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m9.17 58.892 72.85-20.106 30.717 111.295-72.852 20.106z"
}))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#EDF4F3",
  d: "m14.602 61.873 64.28-17.741 23.261 84.28-64.28 17.74z"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  d: "M37.548 94.11a4.982 4.982 0 0 1 3.431-6.154l3.427-.973a4.982 4.982 0 0 0 2.36-1.48l2.009-2.256a4.98 4.98 0 0 1 2.36-1.48l3.411-.969 3.412-.969a4.981 4.981 0 0 1 2.785.019l2.896.864c.908.27 1.874.277 2.785.019l3.427-.974a4.982 4.982 0 0 1 6.153 3.432l4.538 15.98a4.982 4.982 0 0 1-3.431 6.153l-28.872 8.199a4.982 4.982 0 0 1-6.153-3.431l-4.538-15.98Z",
  fill: "#405B73",
  fillOpacity: 0.85
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  d: "M56.394 86.888c-5.476 1.555-8.677 7.278-7.126 12.74 1.551 5.461 7.297 8.698 12.772 7.143 5.476-1.555 8.663-7.329 7.112-12.79-1.551-5.462-7.282-8.648-12.758-7.093Z",
  fill: "#F4CC54",
  fillOpacity: 0.85
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  d: "M57.262 89.945c-3.794 1.077-6.009 5.033-4.936 8.812 1.073 3.779 5.052 6.03 8.845 4.953 3.793-1.077 5.994-5.083 4.92-8.862-1.072-3.78-5.036-5.98-8.83-4.903Z",
  fill: "#F3F5F9",
  fillOpacity: 0.85
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  d: "M40.798 92.57a.885.885 0 0 1 .61-1.094l3.406-.968a.885.885 0 1 1 .484 1.704l-3.406.967a.885.885 0 0 1-1.094-.61Z",
  fill: "#F4CC54",
  fillOpacity: 0.85
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  d: "m69.216 79.987-3.406.967a.885.885 0 1 1-.484-1.703l3.406-.967a.885.885 0 1 1 .484 1.703Z",
  fill: "#DDBE5B"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "achievements-empty-state-completed_svg__a",
  x: 129.385,
  y: 99.742,
  width: 88.945,
  height: 88.938,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 3.35
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 3.769
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.620833 0 0 0 0 0.620833 0 0 0 0 0.620833 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_2056_120334"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_2056_120334",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "achievements-empty-state-completed_svg__b",
  x: 24.169,
  y: 57.785,
  width: 115.567,
  height: 143.402,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 1,
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 3
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.825 0 0 0 0 0.825 0 0 0 0 0.825 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_2056_120334"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_2056_120334",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "achievements-empty-state-completed_svg__c",
  x: 79.654,
  y: 52.767,
  width: 83.338,
  height: 82.874,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 3.35
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 3.769
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.620833 0 0 0 0 0.620833 0 0 0 0 0.620833 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_2056_120334"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_2056_120334",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "achievements-empty-state-completed_svg__d",
  x: 102.017,
  y: 0.061,
  width: 84.099,
  height: 80.678,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 3.35
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 3.769
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.620833 0 0 0 0 0.620833 0 0 0 0 0.620833 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_2056_120334"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_2056_120334",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "achievements-empty-state-completed_svg__e",
  x: 4.169,
  y: 34.785,
  width: 115.567,
  height: 143.402,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 1,
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 3
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.825 0 0 0 0 0.825 0 0 0 0 0.825 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_2056_120334"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_2056_120334",
  result: "shape"
})))));
export default SvgAchievementsEmptyStateCompleted;